import { motion } from 'framer-motion';

interface Props {
  value?: number;
  onChange: (value: number) => void;
}

// Palabra amigable según cuánto se oscurece el fondo.
function intensityLabel(v: number): string {
  if (v <= 0) return 'Sin oscurecer';
  if (v < 40) return 'Ligera';
  if (v < 65) return 'Media';
  return 'Intensa';
}

/**
 * Card con un slider para oscurecer la imagen de fondo del hero. Sirve para que
 * el titular no se mezcle con la imagen: a más oscurecido, más legible el texto.
 * Escribe el prop numérico `overlay` (0–100) que ya consume el renderer.
 */
export function OverlayField({ value, onChange }: Props) {
  const v = typeof value === 'number' ? value : 55;

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.22, ease: 'easeOut' }}
      className="rounded-lg border border-ui-border bg-ui-surface p-3.5 space-y-3"
    >
      <div className="flex items-center justify-between gap-3">
        <span className="text-sm text-ui-text-muted">Oscurecido del fondo</span>
        <span className="text-sm font-medium text-ui-text">{intensityLabel(v)}</span>
      </div>

      <input
        type="range"
        min={0}
        max={100}
        step={1}
        value={v}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full accent-ui-accent cursor-pointer"
        aria-label="Oscurecido del fondo"
      />

      <p className="text-sm text-ui-text-subtle leading-snug">
        Sube el oscurecido si el titular se mezcla con la imagen y cuesta leerlo.
      </p>
    </motion.div>
  );
}
